import { useState, useEffect } from 'react';
import Drawer from '../Drawer/Drawer';
import styles from './AddDriverDrawer.module.css';

export default function AddDriverDrawer({
  isOpen,
  onClose,
  onAdd,
  mode = 'add',
  initialData = null,
}) {
  const [form, setForm]       = useState({ name: '', email: '', phone: '', password: '' });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError]     = useState('');
  const isEditMode = mode === 'edit';

  useEffect(() => {
    if (!isOpen) return;
    setForm({
      name: initialData?.name || '',
      email: initialData?.email || '',
      phone: initialData?.phone || '',
      password: '',
    });
    setError('');
  }, [isOpen, initialData]);

  function reset() {
    setForm({ name: '', email: '', phone: '', password: '' });
    setError('');
  }

  function handleClose() { reset(); onClose(); }

  const isValid = form.name.trim() !== '' && form.email.trim() !== '' && (isEditMode || form.password.trim().length >= 8);

  async function handleSubmit() {
    if (!isValid) return;
    setSubmitting(true);
    setError('');
    try {
      await onAdd({
        name:     form.name,
        email:    form.email,
        phone:    form.phone || null,
        password: form.password,
      });
      reset();
    } catch (err) {
      setError(err.message || `Failed to ${isEditMode ? 'update' : 'add'} driver`);
    } finally {
      setSubmitting(false);
    }
  }

  const footer = (
    <button
      className={`${styles.submitBtn} ${!isValid || submitting ? styles.submitBtnDisabled : ''}`}
      disabled={!isValid || submitting}
      onClick={handleSubmit}
    >
      {submitting ? (isEditMode ? 'Saving…' : 'Adding…') : (isEditMode ? 'Save changes' : 'Add new driver')}
    </button>
  );

  return (
    <Drawer isOpen={isOpen} title={isEditMode ? 'Edit driver' : 'Add driver'} onClose={handleClose} footer={footer}>
      <div className={styles.formField}>
        <label className={styles.label}>Name</label>
        <input
          className={styles.input}
          placeholder="e.g. Jane Doe"
          value={form.name}
          onChange={e => setForm(f => ({ ...f, name: e.target.value }))}
        />
      </div>

      <div className={styles.formField}>
        <label className={styles.label}>Email</label>
        <input
          className={styles.input}
          type="email"
          placeholder="e.g. jane@email.com"
          value={form.email}
          onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
        />
      </div>

      <div className={styles.formField}>
        <label className={styles.label}>Password</label>
        <input
          className={styles.input}
          type="password"
          placeholder={isEditMode ? 'Leave blank to keep current password' : 'Min. 8 characters'}
          value={form.password}
          onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
        />
      </div>

      <div className={styles.formField}>
        <label className={styles.label}>Phone</label>
        <input
          className={styles.input}
          type="tel"
          placeholder="e.g. +27 59 000 0000"
          value={form.phone}
          onChange={e => setForm(f => ({ ...f, phone: e.target.value }))}
        />
      </div>
      {error && <p style={{ color: 'var(--red-color)', fontSize: 13, marginTop: 8, fontFamily: '"General Sans", sans-serif' }}>{error}</p>}
    </Drawer>
  );
}
